export const GTM_EVENT_NAME = {
  // GENERAL
  // x__ is technical/informational only event prefix
  SET_USER_DATA: "x__set_user_data",
  APP_INITIALIZE: "app_initialize",
  PAGE_VIEW: "page_view",
  LOGIN: "login",
  LOGOUT: "logout",
  SIGN_UP: "sign_up",
  NEW_USER_SIGN_UP: "new_user_sign_up",
  ONBOARDING_COMPANY_DATA_PROVIDED: "onboarding_company_data_provided",
  FILTER_LOCATIONS: "filter_locations",
  FILTER_DATE_PERIOD: "filter_date_period",
  CHART_MONTH_CHANGE: "chart_monthly_change_month",
  LIST_SEARCH: "list_search",
  LIST_SELECT: "list_select",
  COMPANY_SELECT: "company_select",
  LOCATIONS_PICKER_SELECT: "location_picker_select",
  KEYWORDS_LIST_SELECT: "keywords_list_select",
  BUTTON_CLICK: "button_click",
  NAV_MENU_ITEM_CLICK: "nav_menu_item_click",
  ERROR_SERVICE_UNAVAILABLE: "error_service_unavailable",
  ENGAGED_PAGE_VIEW: "engaged_page_view",
  SHOW_FAQ: "show_faq",
  LIST_PAGING: "list_paging",
  // DASHBOARD
  DASHBOARD_SHOW_DETAILS: "dashboard_show_details",

  // VISIBILITY

  // YOUR COMPETITION
  COMPETITION_LOCATION_SELECT: "competition_location_select",
  COMPETITION_LOCATION_ADD: "competition_location_add",

  // ANALYTICS
  GMB_ANALYTICS_EXPORT: "gmb_analytics_export",
  ANALYTICS_GM_POSITION_CHART_DISPLAYED:
    "analytics_gm_position_chart_displayed",
  ANALYTICS_GM_POSITION_TABLE_DISPLAYED:
    "analytics_gm_position_table_displayed",
  ANALYTICS_COMPARE_LOCATIONS: "analytics_compare_locations",

  // LOCATIONS
  LOCATION_CREATE: "location_create",
  LOCATIONS_EXPORT: "locations_export",
  LOCATIONS_MASS_EDIT_SUMMARY: "bulk_loc_edit_s",
  LOCATIONS_MASS_EDIT_BASIC_DETAILS: "bulk_loc_edit_basic_d",
  LOCATIONS_MASS_EDIT_ATTRIBUTES_DETAILS: "bulk_loc_edit_attributes_d",
  SINGLE_LOCATION_EDIT_SUMMARY: "single_loc_edit_s",
  SINGLE_LOCATION_EDIT_BASIC_DETAILS: "single_loc_edit_basic_d",
  SINGLE_LOCATION_EDIT_ATTRIBUTES_DETAILS: "single_loc_edit_attributes_d",
  LOCATION_DETAILS_ACTION: "loc_details_action",
  LOCATION_PROCESSING_IN_PROGRESS: "loc_processing_in_progress_error",
  LOCATIONS_DISCONNECT: "locations_disconnect",
  BULK_PHOTO_DELETE: "bulk_photo_delete",
  POST_GUIDE_OPEN: "post_guide_open",
  REVIEWS_ANALYTICS_SEARCH: "reviews_analytics_search",
  REVIEW_CATEGORIES_SELECT_DESELECT_BULK:
    "review_categories_select_deselect_bulk",

  // LOCATION GROUPS
  LOCATION_GROUP_CREATE: "location_group_create",
  LOCATION_GROUP_DELETE: "location_group_delete",
  LOCATION_GROUP_EDIT: "location_group_edit",

  // LOCATIONS QUALITY
  LOCATIONS_QUALITY_ITEM_ACTION: "locations_quality_item_action",

  // EXTERNAL CHANGES
  SINGLE_EXTERNAL_CHANGE_ACTION: "single_ext_change_action",
  EXTERNAL_CHANGES_LIST_ACTION: "ext_changes_list_action",
  EXTERNAL_CHANGES_MASS_ACTION_SUMMARY: "bulk_ext_change_action_s",
  EXTERNAL_CHANGES_MASS_ACTION_DETAILS: "bulk_ext_change_action_d",
  EXTERNAL_CHANGES_PROTECT_EXT_CONFIG_CHANGE:
    "ext_changes_protect_config_change",
  EXTERNAL_CHANGES_PROTECT_GMB_CONFIG_CHANGE:
    "gmb_changes_protect_config_change",
  EXTERNAL_CHANGES_PROTECT_CONFIRM: "ext_changes_protect_confirm",

  // PHOTOS
  PHOTO_EDIT: "photo_edit",
  PHOTO_MASS_ADD: "bulk_photo_add",

  // POSTS
  POSTS_MASS_ADD: "bulk_post_add",
  POSTS_MASS_DELETE: "bulk_post_delete",
  POSTS_MASS_EDIT: "bulk_post_edit",
  POSTS_LIST_SCHEDULE_CALENDAR_ACTION: "posts_list_schedule_calendar_action",

  // REVIEWS
  REVIEW_LIST_EXPORT: "review_list_export",
  REVIEW_REPLY_GENERATED_AI: "review_reply_generated_ai",
  REVIEW_REPLY: "review_reply",
  REVIEW_REPLY_BULK: "review_reply_bulk",
  REVIEW_LIST_FILTER_BY_REPLY: "review_list_filter_by_reply",
  EXPORT_LOCATIONS_RATINGS: "locations_ratings_export",
  REVIEW_TEMPLATE_MANAGE_ADD: "review_template_manage_add_template",
  REVIEW_TEMPLATE_MANAGE_ACTION: "review_template_manage_action",
  REVIEW_TEMPLATE_USE: "review_template_use",
  REVIEW_CATEGORIES_MANAGE: "review_categories_manage",
  REVIEW_CATEGORIES_SELECT_DESELECT: "review_categories_select_deselect",
  REVIEWS_SEARCH: "reviews_search",
  REVIEW_CATEGORY_ANALYTICS_OVERVIEW_TABLE_TYPE_CHANGE:
    "review_category_analytics_overview_table_type_change",
  REVIEW_CATEGORY_ANALYTICS_OVERVIEW_TABLE_SEARCH:
    "review_category_analytics_overview_table_search",
  REVIEW_CATEGORY_ANALYTICS_OVERVIEW_TABLE_SORT:
    "review_category_analytics_overview_table_sort",
  REVIEW_CATEGORY_ANALYTICS_OVERVIEW_TABLE_ROW_ACTION:
    "review_category_analytics_overview_table_row_action",
  REVIEW_CATEGORY_ANALYTICS_OVERVIEW_HEATMAP_FULLSCREEN:
    "review_category_analytics_overview_heatmap_fullscreen",
  FILTER_DATE_PERIOD_V2: "filter_date_period_v2",
  FILTER_LOCATIONS_V2: "filter_locations_v2",
  REVIEW_CATEGORY_AUTO_STATUS_CHANGE: "review_category_auto_status_change",
  REVIEW_CATEGORY_KEYWORDS_MANAGE: "review_category_keywords_manage",
  REVIEW_CATEGORY_KEYWORDS_MANAGE_BULK: "review_category_keywords_manage_bulk",
  REVIEW_CATEGORY_KEYWORDS_SEARCH: "review_category_keywords_search",
  REVIEW_CATEGORY_AUTO_SHOW_HELP: "review_category_auto_show_help",
  REVIEW_CATEGORY_ANALYTICS_OVERVIEW_HEATMAP_ACTION:
    "review_category_analytics_overview_heatmap_action",
  REVIEW_CATEGORY_ANALYTICS_DETAILS_CATEGORY_CHANGE:
    "review_category_analytics_details_category_change",
  REVIEW_CATEGORY_ANALYTICS_DETAILS_CHART_TYPE_CHANGE:
    "review_category_analytics_details_chart_type_change",
  REVIEW_CATEGORY_ANALYTICS_DETAILS_CHART_TIMEGROUP_CHANGE:
    "review_category_analytics_details_chart_timegroup_change",
  REVIEW_CATEGORY_ANALYTICS_DETAILS_CHART_SENTIMENT_DETAILS_CONFIG_CHANGE:
    "review_category_analytics_details_chart_sentiment_details_config_change",
  REVIEW_CATEGORY_ANALYTICS_DETAILS_TABLE_TYPE_CHANGE:
    "review_category_analytics_details_table_type_change",
  REVIEW_CATEGORY_ANALYTICS_DETAILS_TABLE_CONFIG_CHANGE:
    "review_category_analytics_details_table_config_change",
  REVIEW_CATEGORY_ANALYTICS_DETAILS_TABLE_SEARCH:
    "review_category_analytics_details_table_search",
  REVIEW_CATEGORY_ANALYTICS_DETAILS_TABLE_SORT:
    "review_category_analytics_details_table_sort",
  REVIEW_CATEGORY_ANALYTICS_DETAILS_TABLE_ACTION:
    "review_category_analytics_details_table_action",
  REVIEW_CATEGORIES_CONFIRM_AUTO_ASSIGNED_CHANGE:
    "review_categories_confirm_auto_assigned_change",
  REVIEW_CATEGORIES_SHOW_MORE: "review_categories_show_more",

  // PERMISSIONS
  PERMISSIONS_USER_REMOVE: "user_remove",
  PERMISSIONS_USER_RESEND_INVITATION: "user_resend_invitation",
  PERMISSIONS_USER_ADD_FULL_ACCESS: "user_add_full_access",
  PERMISSIONS_USER_ADD_LIMITED_ACCESS_SUMMARY: "user_add_limited_access_s",
  PERMISSIONS_USER_ADD_LIMITED_ACCESS_DETAILS: "user_add_limited_access_d",

  // ACCOUNTS
  GMB_ACCOUNT_ADD: "gmb_account_add",
  GMB_ACCOUNT_REMOVE: "gmb_account_remove",
  GMB_ACCOUNT_PROFILE_ADD: "gmb_account_profile_add",
  GMB_ACCOUNT_PROFILE_LOCATIONS_EDIT: "gmb_account_profile_locations_edit",

  // WIZARD
  WIZARD_COMPLETE: "wizard_complete",
  WIZARD_STEP_BACK: "wizard_step_back",
  WIZARD_KEYWORD_ADD: "keyword_add",
  WIZARD_KEYWORD_REMOVE: "keyword_remove",
  WIZARD_STEP_1_COMPANY_ACTION: "wizard_step1_company_action",
  WIZARD_STEP_2_LOCATIONS_ACTION: "wizard_step2_locations_action",
  WIZARD_STEP_3_KEYWORDS_ACTION: "wizard_step3_keywords_action",

  // LINKS FROM EMAILS
  NOTIFICATION_REVIEWS: "notif_reviews_action",
  NOTIFICATION_EXTERNAL_CHANGES: "notif_ext_changes_action",

  //VIDEO TUTORIALS
  HELP_VIDEO_SHOW: "help_video_show",

  //CSV REPORTS
  ANALYTICS_GM_POSITION_TABLE_EXPORT: "analytics_gm_position_table_export",

  LOGIN_STATUS: "login_status",
  SUBSCRIPTION_STATUS: "subscription_status",

  //REVIEW BOOSTER
  RB_FORM_LIST_LINKS_EXPORT: "rb_form_list_links_export",
  RB_FORM_LIST_STATS_EXPORT: "rb_form_list_stats_export",
  RB_REVIEW_LIST_EXPORT: "rb_review_list_export",
  RB_REVIEW_LIST_FORM_SELECT: "rb_review_list_form_select",
  RB_REVIEW_LIST_SHOW_MORE_QUESTIONS: "rb_review_list_show_more_questions",
  RB_REVIEW_LIST_SHOW_FULL_REVIEW: "rb_review_list_show_full_review",
  //NOTES
  REVIEW_LIST_NOTE_ACTION: "review_list_note_action",

  // SERVICES
  SERVICES_EDIT: "services_edit",
  SERVICES_BULK_EDIT: "services_bulk_edit",

  // FREE TRIAL
  FREE_TRIAL_REMINDER_CLICKED: "free_trial_reminder_clicked",

  // PAYMENTS
  SUBSCRIPTION_PLAN_CONFIGURED: "subscription_plan_configured",
  BILLING_DATA_PROVIDED: "billing_data_provided",
  BILLING_DATA_LOADED_AUTOMATICALLY_FOR_TAX_ID:
    "billing_data_loaded_automatically_for_tax_id",
  PAYMENT_STARTED: "payment_started",
  PAYMENT_FINISHED: "payment_finished",
  SUBSCRIPTION_SETTINGS_BILLING_DATA_UPDATED:
    "subscription_settings_billing_data_updated",
  SUBSCRIPTION_SETTINGS_BILLING_DATA_LOADED_AUTOMATICALLY_FOR_TAX_ID:
    "subscription_settings_billing_data_loaded_automatically_for_tax_id",
  SUBSCRIPTION_SETTINGS_PLAN_SELECTION_STARTED:
    "subscription_settings_plan_selection_started",
  SUBSCRIPTION_SETTINGS_SUBSCRIPTION_MANAGEMENT_PANEL_OPENED:
    "subscription_settings_subscription_management_panel_opened",

  // QUESTIONS AND ANSWERS
  QA_FILTERED_BY_REPLY: "qa_filtered_by_reply", //tab change
  QA_ADD_QUESTION_AND_ANSWER: "qa_add_question_and_answer",
  QA_ADDED_QUESTION_AND_ANSWER: "qa_added_question_and_answer",
  QA_ADDED_ANSWER: "qa_added_answer",
  QA_EDITED_QUESTION: "qa_edited_question",
  QA_EDITED_ANSWER: "qa_edited_answer",
  // POSTS FACEBOOK
  POST_COPY_FROM_FACEBOOK_STARTED: "post_copy_from_facebook_started",
  POST_COPY_FROM_FACEBOOK_PAGE_SELECTED:
    "post_copy_from_facebook_page_selected",
  POST_COPY_FROM_FACEBOOK_POST_REUSED: "post_copy_from_facebook_post_reused"
};

export const GTM_LIST_SELECT_ACTION = {
  CHECK_ALL: "check_all",
  UNCHECK_ALL: "uncheck_all",
  CHECK_ALL_ON_PAGE: "check_all_on_page",
  UNCHECK_ALL_ON_PAGE: "uncheck_all_on_page",
  CHECK: "check",
  UNCHECK: "uncheck"
};

export const GTM_LOCATION_CREATE_ACTION = {
  GMB_IMPORT: "gmb_import",
  WITH_OWNER: "google_maps_with_owner",
  WITHOUT_OWNER: "google_maps_without_owner",
  NEW_LOCATION: "new_location",
  CREATE_DUPLICATE: "create_duplicate",
  ALREADY_IN_CENTER: "already_in_center"
};

export const GTM_ENGAGEMENT_TIME = {
  // time in seconds (to add another one, see also helpers/mixins/gtm-engagement)
  FIRST: 5,
  SECOND: 10
};

export const GTM_PERIOD_TYPE_ACTION = {
  YESTERDAY: "yesterday",
  PREVIOUS_MONTH: "previous_month",
  PREVIOUS_QUARTER: "previous_quarter",
  PREVIOUS_YEAR: "previous_year",
  PREVIOUS_WEEK: "previous_week",
  ALL: "all"
};

export const GTM_FACILITY_FILTER_TYPE_ACTION = {
  ALL_LOCATIONS: "all_locations",
  CITY: "city",
  LOCATIONS_GROUP: "locations_group",
  LOCATION: "location"
};

export const GTM_FACILITY_TAB_NAME = {
  ALL_LOCATIONS: 0,
  CITY: 1,
  LOCATIONS_GROUP: 2,
  LOCATION: 3
};
